<div>
  <button type="button" mat-button class="menu-item w-full" routerLink={{linkTo}}>{{title}}</button>
</div>
